import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import SecureLS from "secure-ls";

function NonProtected({ children }: { children: ReactNode }) {
  const location = useLocation();
  let token = null;
  let ls = null;

  try {
    // Initialize SecureLS
    ls = new SecureLS({ encodingType: "aes" });

    // Try to get the user token
    token = ls.get("user");
    if (token && (location.pathname === "/login" || location.pathname === "/email-verification")) {
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    console.error("Error retrieving user token:", error);

    // Continue with token as null
  }

  return <>{children}</>;
}
export default NonProtected;
